import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { observeAuthState } from '../../services/firebase/auth';
import { AuthGate } from '../components/AuthGate';

const isAuthBypass = import.meta.env.VITE_BYPASS_AUTH === 'true';

export function LoginPage(): JSX.Element {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    if (isAuthBypass) {
      void navigate(searchParams.get('redirect') ?? '/app', { replace: true });
      return;
    }

    const unsubscribe = observeAuthState((user) => {
      if (user) {
        void navigate(searchParams.get('redirect') ?? '/app', { replace: true });
      } else {
        setIsChecking(false);
      }
    });

    return () => {
      unsubscribe();
    };
  }, [navigate, searchParams]);

  if (isChecking) {
    return <div className="flex h-full items-center justify-center">Loading...</div>;
  }

  return <AuthGate />;
}
